export default "__VITE_ASSET__b14fc21b__"